import React from "react";

import logo from "@safecv/assets/Images/image2.png";
import Profile from "./Profile";

import "./NavigationBar.css";

function NavigationBar() {
  return (
    <div className="navwidth">
      <div className="container-fluid">
        <div className="row">
          <div className="zero-padding col-6">
            <img src={logo} className="image" alt="logo" />
          </div>
          <div className="zero-padding col-6">
            <div className="signout">
              <Profile />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NavigationBar;
